import config from "../config";

export type KicktippGame = {
  kickoff: string;
  home: string;
  away: string;
  group: string;
  result: string;
  points_rule: string;
};

export type KicktippMatchdayRow = {
  position: number;
  name: string;
  predictions: Record<string, { prediction: string; points: number }>;
  matchday_points: number;
  bonus_points: number;
  wins: number;
  total_points: number;
};

export type KicktippTotalRow = {
  position: number;
  name: string;
  matchday_points: Record<string, string>;
  bonus_points: number;
  wins: number;
  total_points: number;
};

export type KicktippBonusAnswer = {
  question: string;
  answer: string | null;
  points: string;
};

export type KicktippBonusRow = {
  position: number;
  name: string;
  answers: KicktippBonusAnswer[];
  bonus_points: number;
  total_points: number;
};

export type KicktippLeagueRow = {
  position: number;
  team: string;
  played: number;
  points: number;
  goals_for: number;
  goals_against: number;
  goal_difference: number;
  wins: number;
  draws: number;
  losses: number;
};

export type KicktippData = {
  table: KicktippMatchdayRow[];
  games: KicktippGame[];
  total_table: KicktippTotalRow[];
  bonus_table: KicktippBonusRow[];
  league_table: KicktippLeagueRow[];
};

export const fetchKicktipp = async (): Promise<KicktippData> => {
  const response = await fetch(`${config.apiUrl}/kicktipp`);

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const data = await response.json();
  return data;
};
